import React, { useMemo, useState, useEffect } from "react";
import { Themes as allThemes } from "config/themes";
import { useIsBigScreen } from "utils/useIsBigScreen";
import { useLocalStorage } from "utils/hooks";

let thisHost = window.location.hostname.toLowerCase();
if (window.location.href.includes("holla-africa.com/shop")) {
    thisHost = "shop@holla-africa.com";
}

const checkTheme = (theme) => {
    return !!theme?.enabled && (!theme.hosts || theme.hosts.includes(thisHost));
};

const useTheme = () => {
    const [themeId, setThemeId] = useLocalStorage("com.stargame.selector.theme", "stargame");

    const enabledThemes = useMemo(() => {
        return allThemes.filter(checkTheme);
    }, []);

    const [currentTheme, setCurrentTheme] = useState(null);

    useEffect(() => {
        const url = new URL(window.location.href);
        const themeIdFromQuery = url.searchParams.get("themeId");

        let theme;

        if (themeIdFromQuery) {
            theme = allThemes.find(
                (t) =>
                    t.id === themeIdFromQuery &&
                    t.enabled &&
                    (t.hosts?.includes(thisHost) || t.id === "live")
            );
            if (theme) {
                setThemeId(theme.id);
                setCurrentTheme(theme);
                return;
            }
        }

        theme = enabledThemes.find((t) => t.id === themeId) || enabledThemes[0];
        if (theme) {
            setThemeId(theme.id);
            setCurrentTheme(theme);
        }
    }, [themeId, enabledThemes, setThemeId]);

    const isBigScreen = useIsBigScreen();

    const changeTheme = (newThemeId) => {
        const theme = enabledThemes.find((t) => t.id === newThemeId);
        if (theme) {
            setThemeId(newThemeId);
            setCurrentTheme(theme);
        }
    };

    return [currentTheme, changeTheme, enabledThemes, isBigScreen && !!currentTheme?.allowSplitScreen];
};

export const ThemingContext = React.createContext(null);

export const ThemingProvider = ({ children }) => (
    <ThemingContext.Provider value={useTheme()}>
        {children}
    </ThemingContext.Provider>
);
